import { forwardRef } from "react";

import PropTypes from "prop-types";

import ItemContainer from "../Item/Container";
import ItemPlaceholder from "../Item/Placeholder";

const Section = forwardRef(
  ({ section, items, renderItem, isDragAndDropDisabled }, ref) => (
    <div
      {...{ ref }}
      className="neeto-molecules-boardview-section__body relative min-h-0 flex-1 basis-0 overflow-y-auto"
    >
      <ItemPlaceholder data={{ section }} />
      {items.map((item, index) => (
        <ItemContainer
          {...{ index, isDragAndDropDisabled }}
          data={{ section, item }}
          id={`${section.id}--${item.id}`}
          key={`${section.id}--${item.id}`}
          render={() => renderItem({ index, item, section })}
        />
      ))}
    </div>
  )
);

Section.displayName = "Section";
Section.propTypes = {
  /** A reference to the section container element. */
  // eslint-disable-next-line react/no-unused-prop-types
  ref: PropTypes.any,

  /** The current section data   */
  section: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,

  /** When true, disables all drag and drop functionality for the section */
  isDragAndDropDisabled: PropTypes.bool,

  /** An array of items belonging to the current section. */
  items: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired }))
    .isRequired,

  /** A function that renders the content of each item in the list. */
  renderItem: PropTypes.func.isRequired,
};

export default Section;
